import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const NavLink = styled(Link)`
  display: block; /* Make the link take the full width */
  text-decoration: none;
  margin-bottom: 10px; /* Space between cards */
`

export const VideoCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%; /* Ensure full width */
  list-style-type: none;
  cursor: pointer;
  margin: 0; /* Remove margin for a single card */
  border-bottom: 1px solid #ccc; /* Change color for better visibility */
  padding: 15px; /* Adjust padding for better aesthetics */
  background-color: ${props =>
    props.bgColor || '#fff'}; /* Add bg color from props */
`

export const ThumbnailImage = styled.img`
  width: 50%; /* Adjust to fit your design */
  height: auto; /* Maintain aspect ratio */
  object-fit: cover; /* Cover to fill the space */
`

export const VideoDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 25px; /* Keep space from the thumbnail */
  flex: 1; /* Allow details to take the remaining space */
`

export const VideoDetailsText = styled.p`
  color: ${props => props.textColor || '#000'};
  font-family: 'Roboto', sans-serif;
  font-size: ${props => props.size}px;
  font-weight: bold;
`

export const VideoCardBottomContainer = styled.div`
  display: flex;
  width: 100%; /* Ensure the bottom container takes full width */
  align-items: center;
`
